import controller from './address-selector.controller';
import template from './address-selector.html';
import './address-selector.scss';

let AddressSelectorComponent = {
	bindings: {
		doctorList: '<',
		minCharacter: '<',
		activateOnFocus: '<',
		searchFields: '<',
		language: '<',
		onSelect: '&',
	},
	controller,
	template
};

export default AddressSelectorComponent;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/address-selector/address-selector.component.js